import {makeStyles} from "@material-ui/core"

export default makeStyles(theme => ({
    container: {
        padding: theme.spacing(2),
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginTop: 30,
        backgroundColor: "rgba(250, 84, 101, 0.2)"
    },
    label: {
        fontSize: 16,
    },
    label__bold: {
        fontWeight: 600,
    }
}))